(() => {
  const formSelector = '.lyo-footer-form__form';
  const submitSelector = '[data-lyo-footer-contact-submit]';
  const labelSelector = '[data-lyo-footer-contact-submit-label]';

  function setSubmittingState(form, button) {
    const label = button.querySelector(labelSelector);

    if (!(label instanceof HTMLElement)) return;

    button.dataset.originalLabel ||= label.textContent.trim();
    label.textContent = button.dataset.submittingLabel || 'Enviando...';
    button.setAttribute('aria-busy', 'true');
    form.setAttribute('aria-busy', 'true');
  }

  function resetSubmittingState(form, button) {
    const label = button.querySelector(labelSelector);

    if (label instanceof HTMLElement && button.dataset.originalLabel) {
      label.textContent = button.dataset.originalLabel;
    }

    button.removeAttribute('aria-busy');
    form.removeAttribute('aria-busy');
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      const button = target instanceof Element ? target.closest(submitSelector) : null;
      const form = button?.closest(formSelector);

      if (!(button instanceof HTMLButtonElement) || !(form instanceof HTMLFormElement)) return;

      setSubmittingState(form, button);

      if (!form.checkValidity()) {
        requestAnimationFrame(() => resetSubmittingState(form, button));
      }
    },
    { capture: true }
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;
      if (!form.checkValidity()) return;

      const button = form.querySelector(submitSelector);

      if (button instanceof HTMLButtonElement) {
        setSubmittingState(form, button);
      }
    },
    { capture: true }
  );

  document.querySelectorAll('[data-lyo-footer-contact-success]').forEach((popup) => {
    const dismissAfter = Number.parseInt(popup.dataset.dismissAfter || '4000', 10);

    window.setTimeout(() => {
      popup.classList.add('is-dismissing');

      window.setTimeout(() => {
        popup.hidden = true;
      }, 200);
    }, dismissAfter);
  });
})();
